module.exports = __webpack_public_path__ + "images/sprites/ui/icon_phone_orange_f8c0021afab9134f33cab8f1b8106ce4.png";